<template>
    <Typography
        is="ul"
        type="paragraph"
        size="s"
        :responsive="false"
        :class="$style.breadcrumbs"
    >
        <li
            v-for="(breadcrumb, index) in props.breadcrumbs"
            :key="breadcrumb.title"
        >
            <Link
                :to="breadcrumb.href"
                :class="index === props.breadcrumbs.length - 1 && $style.disabled_link"
                color="purple-600"
                data-interface-target="breadcrumb"
            >
                {{ breadcrumb.title }}
                <meta
                    itemprop="position"
                    :content="`${index + 1}`"
                />
            </Link>
            {{ index !== props.breadcrumbs.length - 1 ? '\u00A0/\u00A0' : '' }}
        </li>
    </Typography>
</template>

<script setup lang="ts">
import { RouteLocationRaw } from 'vue-router'

import Link from '@/components_new/Link.vue'
import Typography from '@/components_new/Typography.vue'

const props = defineProps<{
    breadcrumbs: { href: string | RouteLocationRaw; title: string }[]
}>()
</script>

<style module>
.breadcrumbs {
    display: flex;
    flex-wrap: wrap;
    color: var(--white-20);
    line-height: 1.5;
}

.breadcrumbs * {
    white-space: nowrap;
}
.disabled_link {
    color: var(--white-60);
    pointer-events: none;
}
</style>
